export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      myTasks: 'My Tasks',
      findJobs: 'Find Jobs',
      about: 'About',
      signOut: 'Sign Out',
      profile: 'Profile'
    },
    home: {
      welcome: 'Welcome to Podiweda.com',
      subtitle: 'Find local help for everyday tasks',
      postTask: 'Post a Task',
      browseServices: 'Browse Services',
      howItWorks: 'How It Works',
      step1Title: 'Post Your Task',
      step1Desc: 'Describe what you need done',
      step2Title: 'Get Applications',
      step2Desc: 'Freelancers apply to your job',
      step3Title: 'Choose & Complete',
      step3Desc: 'Select the best fit and get it done',
      ourServices: 'Our Services',
      lookingForWork: 'Looking for work?',
      findJobsDesc: 'Find available jobs and start earning',
      findJobs: 'Find Jobs',
      activeTasks: 'Active Tasks',
      totalTasks: 'Total Tasks',
      totalBudget: 'Total Budget',
      noTasksYet: 'No tasks posted yet. Click "Post New Task" to get started!'
    },
    auth: {
      signIn: 'Sign In',
      signUp: 'Sign Up',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      forgotPassword: 'Forgot password?',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      verifyEmail: 'Verify Email',
      verificationCode: 'Verification Code',
      resetPassword: 'Reset Password',
      newPassword: 'New Password'
    },
    task: {
      title: 'Task Title',
      description: 'Description',
      category: 'Category',
      district: 'District',
      city: 'City',
      address: 'Address',
      phoneNumber: 'Phone Number',
      budget: 'Budget',
      budgetType: 'Budget Type',
      dueDate: 'Due Date',
      taskType: 'Task Type',
      status: 'Status',
      postTask: 'Post Task',
      editTask: 'Edit Task',
      updateTask: 'Update Task',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete'
    },
    categories: {
      cleaning: 'Cleaning',
      handyman: 'Handyman',
      delivery: 'Delivery',
      gardening: 'Gardening',
      moving: 'Moving',
      assembly: 'Assembly',
      photography: 'Photography',
      writing: 'Writing',
      design: 'Design',
      elderlyCare: 'Elderly Care',
      other: 'Other'
    },
    services: {
      cleaningTitle: 'Cleaning Services',
      cleaningDesc: 'Professional home and office cleaning',
      handymanTitle: 'Handyman Services',
      handymanDesc: 'Repairs, installations, and maintenance',
      deliveryTitle: 'Delivery Services',
      deliveryDesc: 'Fast and reliable delivery solutions',
      gardeningTitle: 'Gardening',
      gardeningDesc: 'Landscaping and garden maintenance',
      movingTitle: 'Moving Services',
      movingDesc: 'Packing, moving, and relocation help',
      assemblyTitle: 'Assembly',
      assemblyDesc: 'Furniture and equipment assembly',
      photographyTitle: 'Photography',
      photographyDesc: 'Professional photo and video services',
      writingTitle: 'Writing',
      writingDesc: 'Content writing and copywriting',
      designTitle: 'Design',
      designDesc: 'Graphic design and creative services',
      elderlyCareTitle: 'Elderly Care',
      elderlyCareDesc: 'Compassionate care for seniors',
      hospitalTitle: 'Hospital Stays Assistance',
      hospitalDesc: 'Support during hospital stays',
      manyMoreTitle: 'Many More Services',
      manyMoreDesc: 'Explore all available services'
    },
    taskTypes: {
      inPerson: 'In Person',
      remote: 'Remote'
    },
    budgetTypes: {
      fixed: 'Fixed Price',
      hourly: 'Hourly Rate'
    },
    about: {
      title: 'About',
      whoWeAre: 'Who We Are',
      whoWeAreText: "Podiweda.com is Sri Lanka's premier freelance marketplace connecting talented professionals with clients who need their services. We bridge the gap between skilled freelancers and businesses looking for quality work.",
      ourMission: 'Our Mission',
      ourMissionText: 'To empower Sri Lankan freelancers and businesses by providing a trusted, efficient platform where quality work meets opportunity. We believe in creating economic opportunities for everyone, from students to professionals.',
      whyChoose: 'Why Choose Podiweda?',
      whyChooseItems: [
        'Local Focus: Built specifically for the Sri Lankan market',
        'Secure Platform: Safe payments and verified users',
        'Wide Range of Services: From cleaning to design, we cover it all',
        'Easy to Use: Simple interface for posting jobs and finding work',
        'Community Driven: Supporting local talent and businesses'
      ],
      ourValues: 'Our Values',
      ourValuesItems: [
        'Trust: Building a reliable platform for all users',
        'Quality: Ensuring high standards in every transaction',
        'Innovation: Continuously improving our services',
        'Community: Supporting Sri Lankan talent and businesses'
      ]
    },
    jobs: {
      availableJobs: 'Available Jobs',
      allCategories: 'All Categories',
      allTypes: 'All Types',
      allDistricts: 'All Districts'
    }
  },
  si: {
    nav: {
      home: 'මුල් පිටුව',
      services: 'සේවා',
      myTasks: 'මගේ කාර්යයන්',
      findJobs: 'රැකියා සොයන්න',
      about: 'අප ගැන',
      signOut: 'ඉවත් වන්න',
      profile: 'පැතිකඩ'
    },
    home: {
      welcome: 'Podiweda.com වෙත සාදරයෙන් පිළිගනිමු',
      subtitle: 'එදිනෙදා කාර්යයන් සඳහා දේශීය උදව් සොයන්න',
      postTask: 'කාර්යයක් පළ කරන්න',
      browseServices: 'සේවා බලන්න',
      howItWorks: 'මේක ක්රියා කරන්නේ',
      step1Title: 'ඔබේ කාර්යය පළ කරන්න',
      step1Desc: 'ඔබට අවශ්ය දේ විස්තර කරන්න',
      step2Title: 'අරජී ලබා ගන්න',
      step2Desc: 'නිදහස් සේවකයින් ඔබේ රැකියාව සඳහා අරජී කරනවා',
      step3Title: 'තෝරා නිමවන්න',
      step3Desc: 'සෑල්සම වැඩිහිටිය තෝරා කාර්යය නිමවන්න',
      ourServices: 'අපගේ සේවා',
      lookingForWork: 'වැඩ සොයනවාද?',
      findJobsDesc: 'වැඩ සොයා ඉරුම් ගන්න',
      findJobs: 'රැකියා සොයන්න',
      activeTasks: 'සක්රිය කාර්ය',
      totalTasks: 'මෝට කාර්ය',
      totalBudget: 'මෝට අයවැය',
      noTasksYet: 'කාර්ය පළ කර නැත. ඇරුම් කිරීමට "කාර්යයක් පළ කරන්න" ක්ලික් කරන්න!'
    },
    auth: {
      signIn: 'පුරනය වන්න',
      signUp: 'ලියාපදිංචි වන්න',
      email: 'විද්‍යුත් තැපෑල',
      password: 'මුරපදය',
      name: 'නම',
      forgotPassword: 'මුරපදය අමතක ද?',
      dontHaveAccount: 'ගිණුමක් නැද්ද?',
      alreadyHaveAccount: 'දැනටමත් ගිණුමක් තිබේද?',
      verifyEmail: 'විද්‍යුත් තැපෑල සත්‍යාපනය කරන්න',
      verificationCode: 'සත්‍යාපන කේතය',
      resetPassword: 'මුරපදය නැවත සකසන්න',
      newPassword: 'නව මුරපදය'
    },
    task: {
      title: 'කාර්ය මාතෘකාව',
      description: 'විස්තරය',
      category: 'වර්ගය',
      district: 'දිස්ත්‍රික්කය',
      city: 'නගරය',
      address: 'ලිපිනය',
      phoneNumber: 'දුරකථන අංකය',
      budget: 'අයවැය',
      budgetType: 'අයවැය වර්ගය',
      dueDate: 'නිමවීමේ දිනය',
      taskType: 'කාර්ය වර්ගය',
      status: 'තත්ත්වය',
      postTask: 'කාර්යයක් පළ කරන්න',
      editTask: 'කාර්යය සංස්කරණය කරන්න',
      updateTask: 'කාර්යය යාවත්කාලීන කරන්න',
      cancel: 'අවලංගු කරන්න',
      edit: 'සංස්කරණය',
      delete: 'මකන්න'
    },
    categories: {
      cleaning: 'පිරිසිදු කිරීම',
      handyman: 'අත්කම්කරු',
      delivery: 'බෙදාහැරීම',
      gardening: 'උද්‍යාන වැඩ',
      moving: 'ගෙන යාම',
      assembly: 'එකලස් කිරීම',
      photography: 'ඡායාරූපකරණය',
      writing: 'ලිවීම',
      design: 'නිර්මාණය',
      elderlyCare: 'වැඩිහිටි සත්කාර',
      other: 'වෙනත්'
    },
    services: {
      cleaningTitle: 'පිරිසිදු කිරීමේ සේවා',
      cleaningDesc: 'ව්යාවසායික ගේහැලි සහ කාර්යාලය පිරිසිදු කිරීම',
      handymanTitle: 'අත්කම්කරු සේවා',
      handymanDesc: 'රිපේයර්, ස්ථාපනය සහ පරිපාලනය',
      deliveryTitle: 'බේදාහැරීමේ සේවා',
      deliveryDesc: 'වේගවත් සහ විශ්වාසදායක බේදාහැරීම',
      gardeningTitle: 'උද්යාන වැඩ',
      gardeningDesc: 'ප්රකෘති සජීවීකරණය සහ උද්යාන පරිපාලනය',
      movingTitle: 'ගෙන යාමේ සේවා',
      movingDesc: 'පැකේජ් කිරීම, ගෙන යාම සහ ස්ථානාන්තරය සහාය',
      assemblyTitle: 'එකලස් කිරීම',
      assemblyDesc: 'පිරිසරා සහ උපකරණ එකලස් කිරීම',
      photographyTitle: 'ඡායාරූපකරණය',
      photographyDesc: 'ව්යාවසායික ඡායාරූප සහ වීඩියෝ සේවා',
      writingTitle: 'ලිවීම',
      writingDesc: 'පරිමාණ ලියන්න සහ ප්රතිලිපි ලියන්න',
      designTitle: 'නිර්මාණය',
      designDesc: 'ග්රාෆික් නිර්මාණය සහ සෘජනාත්මක සේවා',
      elderlyCareTitle: 'වැඩිහිටි සත්කාර',
      elderlyCareDesc: 'වයස්කයින් සඳහා කරුණාමය සත්කාර',
      hospitalTitle: 'රුග්ණසාලාවල සහාය',
      hospitalDesc: 'රුග්ණසාලාවල සිටීම සහාය',
      manyMoreTitle: 'තවත් සේවා',
      manyMoreDesc: 'සියලුම සේවා ඉගෙන ගන්න'
    },
    taskTypes: {
      inPerson: 'පුද්ගලිකව',
      remote: 'දුරස්ථව'
    },
    budgetTypes: {
      fixed: 'ස්ථාවර මිල',
      hourly: 'පැය අනුපාතය'
    },
    about: {
      title: 'අප ගැන',
      whoWeAre: 'අපි කවුද',
      whoWeAreText: 'Podiweda.com යනු ශ්‍රී ලංකාවේ ප්‍රමුඛතම නිදහස් වෙළඳපොළ වන අතර දක්ෂ වෘත්තිකයන් ඔවුන්ගේ සේවා අවශ්‍ය සේවාදායකයන් සමඟ සම්බන්ධ කරයි. අපි ගුණාත්මක වැඩ සොයන දක්ෂ නිදහස් සේවකයින් සහ ව්‍යාපාර අතර පරතරය පියවමු.',
      ourMission: 'අපගේ මෙහෙවර',
      ourMissionText: 'ගුණාත්මක වැඩ අවස්ථාව හමුවන විශ්වාසදායක, කාර්යක්ෂම වේදිකාවක් සැපයීමෙන් ශ්‍රී ලංකික නිදහස් සේවකයින් සහ ව්‍යාපාර සවිබල ගැන්වීම. සිසුන්ගේ සිට වෘත්තිකයන් දක්වා සියල්ලන් සඳහා ආර්ථික අවස්ථා නිර්මාණය කිරීම අපි විශ්වාස කරමු.',
      whyChoose: 'පොඩිවැඩ තෝරා ගන්නේ ඇයි?',
      whyChooseItems: [
        'දේශීය අවධානය: ශ්‍රී ලංකා වෙළඳපොළ සඳහා විශේෂයෙන් ගොඩනගා ඇත',
        'ආරක්ෂිත වේදිකාව: ආරක්ෂිත ගෙවීම් සහ සත්‍යාපිත පරිශීලකයින්',
        'පුළුල් සේවා පරාසයක්: පිරිසිදු කිරීමේ සිට නිර්මාණය දක්වා, අපි සියල්ල ආවරණය කරමු',
        'භාවිතයට පහසු: රැකියා පළ කිරීම සහ වැඩ සොයා ගැනීම සඳහා සරල අතුරු මුහුණත',
        'ප්‍රජාව මෙහෙයවනු ලැබේ: දේශීය දක්ෂතා සහ ව්‍යාපාර සඳහා සහාය වීම'
      ],
      ourValues: 'අපගේ වටිනාකම්',
      ourValuesItems: [
        'විශ්වාසය: සියලුම පරිශීලකයින් සඳහා විශ්වසනීය වේදිකාවක් ගොඩනැගීම',
        'ගුණාත්මකභාවය: සෑම ගනුදෙනුවකම ඉහළ ප්‍රමිතීන් සහතික කිරීම',
        'නවෝත්පාදනය: අපගේ සේවා අඛණ්ඩව වැඩිදියුණු කිරීම',
        'ප්‍රජාව: ශ්‍රී ලංකික දක්ෂතා සහ ව්‍යාපාර සඳහා සහාය වීම'
      ]
    },
    jobs: {
      availableJobs: 'ලබා ගත හැකි රැකියා',
      allCategories: 'සියලුම වර්ග',
      allTypes: 'සියලුම වර්ග',
      allDistricts: 'සියලුම දිස්ත්රික්ක'
    }
  }
};
